import styled from 'styled-components/macro';

const Btn = styled.button`
  background-color: ${props => props.theme.colors.shareButton};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  border-color: transparent;
  width: auto;
  height: 50px;
  font-family: ${props => props.theme.fontset.protext};
  font-stretch: normal;
  font-style: normal;
  white-space: nowrap;
  letter-spacing: normal;
  padding: 0;
`;

const BtnWrapper = styled.div`
  display: flex;
  align-items: center;

  @media ${props => props.theme.device.mobile} {
    justify: space-between;
  }

  &.share-button {
    button {
      width: 66px;
      transition: width 1s;
      display: flex;

      &.open {
        width: 100%;
        justify-content: flex-start;
        transition: width 0.4s;

        @media ${props => props.theme.device.mobile} {
          width: 100%;
        }

        .share-icon-wrapper {
          margin-left: 0;
          transition: margin 0.7s;
        }

        .share-text {
          opacity: 1;
          width: 100%;
          color: ${props => props.theme.colors.shareButtonFont};
          transition: opacity 2s;
        }
      }
    }
  }

  .share-text {
    display: flex !important;
    opacity: 0;
    transition: opacity 0.5s;
  }

  input {
   background: transparent;
   border: none;
   padding: 0;
   max-height: 50px;
  }
`;

const ShareIcon = styled.div`
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='23' viewBox='0 0 21 23' fill='none'%3E%3Cpath d='M7 13L14 16' stroke='%2333A7B2' stroke-width='2' stroke-linejoin='round'/%3E%3Cpath d='M14 6L7 10' stroke='%2333A7B2' stroke-width='2' stroke-linejoin='round'/%3E%3Cpath d='M6.80417 13.7362C8.05678 12.4826 8.05678 10.4501 6.80417 9.19644C5.55155 7.94283 3.52067 7.94283 2.26806 9.19644C1.01544 10.4501 1.01544 12.4826 2.26806 13.7362C3.52067 14.9898 5.55155 14.9898 6.80417 13.7362Z' stroke='%2333A7B2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M18.7319 20.7303C19.9845 19.4767 19.9845 17.4442 18.7319 16.1906C17.4793 14.937 15.4484 14.937 14.1958 16.1906C12.9432 17.4442 12.9432 19.4767 14.1958 20.7303C15.4484 21.9839 17.4793 21.9839 18.7319 20.7303Z' stroke='%2333A7B2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 5.65685 14.3431 7 16 7Z' stroke='%2333A7B2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  margin-left: -5px ;
`;

const SubmitShare = styled.div`
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'%3E%3Cpath d='M12.7531 9.11112L12.7531 9.11111C12.7727 9.10908 12.7901 9.09654 12.805 9.08374C12.8105 9.07899 12.8161 9.07387 12.8215 9.06891C12.8235 9.06707 12.8255 9.06524 12.8274 9.06347C12.8348 9.05678 12.8419 9.0506 12.8489 9.04547L12.8624 9.03561L12.848 9.02711C12.841 9.02295 12.8338 9.0179 12.8264 9.01243C12.8191 9.00707 12.8113 9.00116 12.8036 8.99584C12.7884 8.98532 12.7711 8.97531 12.7522 8.97411L12.7522 8.97411C12.3094 8.94732 11.8663 8.92256 11.4233 8.89781C11.2843 8.89004 11.1452 8.88227 11.0062 8.87443L9.33152 8.78059L7.65685 8.68675L5.97118 8.59257L4.28551 8.4984C4.12388 8.48934 3.96224 8.47999 3.80059 8.47064C3.3693 8.44568 2.93791 8.42073 2.50621 8.40136C2.45028 8.39886 2.41469 8.38884 2.39036 8.36804C2.36606 8.34726 2.35101 8.314 2.34049 8.25996C2.19373 7.50491 2.04324 6.75067 1.89275 5.99642C1.85326 5.79848 1.81376 5.60054 1.77434 5.40258C1.49095 3.97762 1.20719 2.55266 0.923405 1.12754C0.89519 0.985849 0.866975 0.844159 0.83876 0.702468L0.827973 0.704616L0.838764 0.702485C0.834424 0.680507 0.830914 0.658568 0.826511 0.631048C0.82494 0.621231 0.823255 0.610704 0.821379 0.599211L18.148 8.97055C12.2839 11.9231 6.44603 14.8624 0.586077 17.8126C0.604403 17.7299 0.622132 17.6497 0.639516 17.5709C0.674501 17.4125 0.708089 17.2604 0.742329 17.1085C0.848383 16.6374 0.954473 16.1664 1.06056 15.6954C1.47943 13.8356 1.89829 11.9759 2.3149 10.1158C2.32683 10.0625 2.3406 10.0269 2.36467 10.0031C2.38846 9.97968 2.42404 9.96621 2.48365 9.96179C3.07147 9.91892 3.65878 9.86936 4.246 9.8198C4.4185 9.80524 4.591 9.79068 4.7635 9.77629C5.10083 9.74814 5.43816 9.71986 5.77548 9.69157C6.28197 9.64909 6.78847 9.60662 7.29497 9.56462C7.66716 9.53374 8.03941 9.50325 8.41166 9.47275L8.41294 9.47265C8.78562 9.44212 9.15831 9.41159 9.53094 9.38067C10.0009 9.34163 10.4709 9.30224 10.9408 9.26286C11.3184 9.23122 11.6959 9.19958 12.0734 9.16812C12.1474 9.16194 12.2216 9.15615 12.2957 9.15035C12.4482 9.13844 12.6008 9.12652 12.7531 9.11112Z' fill='white' stroke='black' stroke-width='0.0220032'/%3E%3C/svg%3E");
  width: 17px;
  height: 17px;
  background-repeat: no-repeat;
`;

const SubmitShareWrapper = styled.div`
  width: 33px;
  min-width: 33px;
  height: 33px;
  border-radius: 100%;
  background-color: ${props => props.theme.colors.moonstone};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.4s;

  &.visible {
    opacity: 1;
    transition: opacity 0.4s;
  }
`;

const ShareIconWrapper = styled.div`
    min-width: 66px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: margin 0.7s;
`;

const CustomInputWrapper = styled.div`
  div {
    width: 100%;
    max-height: 50px;
    margin-bottom: 0;
    padding: 0;
    padding-right: 10px;
  }

  span {
    left: 0;
    text-align: left;
  }

  input:focus {
    border: none;
    box-shadow: none;

    span {
      display: none;
    }
  }
`;

export { Btn, ShareIcon, ShareIconWrapper, BtnWrapper, SubmitShare, SubmitShareWrapper, CustomInputWrapper };
